<!-- 此文件用于通用编辑页面，接受文章连接（非必须） -->
<template>
  <div>
    <!-- titie cover tag -->

    <div id="mdInfos">

      <el-upload class="avatar-uploader" id="mdCover" :action="`${$axios.defaults.baseURL}/api/img/upload`"
        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
        :with-credentials="true">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>

      <div id="mdComments">

        <el-input placeholder="title" v-model="article.title">
        </el-input>

        <el-input placeholder="excerpt" v-model="article.excerpt">
        </el-input>

        <el-input placeholder="tag" v-model="article.tag">
        </el-input>

        <div class="block">
          <el-cascader v-model="tagsSelected" :options="tags" :show-all-levels="false" @change="test"
            :props="{ expandTrigger: 'hover', multiple: true, checkStrictly: true, value: 'categoryId', label: 'categoryName' }"
            clearable>
            <!-- <template slot-scope="{ node, data }">
,                        <span>{{ data.categoryName }}123</span>
                    </template> -->
          </el-cascader>
        </div>

      </div>

    </div>

    <textarea ref="markdownEditor"></textarea>
  </div>
</template>

<script>
import SimpleMDE from 'simplemde';


import '@/inline-attachment'
import '@/codemirror-4.inline-attachment'
import { conforms } from 'lodash';


export default {
  data() {
    return {
      article: {
        id: null,
        title: "",
        excerpt: "",
        coverId: null,
        content: "",
        tag: "",

      },
      imageUrl: '',
      tagsSelected: [],
      tagsKv: {},
      tags: [{
        value: 'zhinan',
        label: '指南',
        children: [{
          value: 'shejiyuanze',
          label: '设计原则',
          children: [{
            value: 'yizhi',
            label: '一致'
          }, {
            value: 'fankui',
            label: '反馈'
          }, {
            value: 'xiaolv',
            label: '效率'
          }, {
            value: 'kekong',
            label: '可控'
          }],

        }]
      }],
      preTagsId: [],
    }
  },
  props: {
    id: {
      required: false, //必要性
      default: null,
    },
  },
  watch: {
    article(newData, orDate) {
      this.simplemde.value(newData.content)
    },
  },
  mounted() {
    this.fetchArticleById()


    this.whatThemeNow()

    // 初始化 SimpleMDE 编辑器



    this.initMdeAndImageUploader()



  },
  beforeDestroy() {
    // 在组件销毁前销毁 SimpleMDE 实例，防止内存泄漏
    if (this.simplemde) {
      this.simplemde.toTextArea();
      this.simplemde = null;
    }
  },
  methods: {
    fetchArticleById(){
    if (this.id) {
      this.$axios.get(`/api/article/get/${this.id}`)
        .then(res => {
          const article = res.data;
          if (article) {
            this.article = article
            const urlImgcol = article.urlImgcol
            if (urlImgcol) {
              this.imageUrl = urlImgcol
              //Todo  这个逻辑好像无效了,服务器不再返回这个url
            }
              this.fetchTags()

          } else {
            console.log("无效的文章id")
          }

        })
        .catch(res => {
          console.log(res)
        }
        )
    } else {
      console.log("没有传入id，可能是新增文档")
    }
    },
    initMdeAndImageUploader(){

          this.simplemde = new SimpleMDE({
      element: this.$refs.markdownEditor,
      // 其他 SimpleMDE 配置选项
      toolbar: [
        //     {
        //     name: "bold",
        //     action: SimpleMDE.toggleBold,
        //     className: "fa fa-bold",
        //     title: "Bold",
        // },
        // {
        //     name: "code",
        //     action: SimpleMDE.toggleCodeBlock,
        //     className: "fa fa-code",
        //     title: "Bold",
        // },
        // {
        //     name: "quote",
        //     action: SimpleMDE.toggleBlockquote,
        //     className: "fa fa-quote-left",
        //     title: "Quote",
        // },




        {
          name: "link",
          action: SimpleMDE.drawLink,
          className: "fa fa-link",
          title: "Create Link",
        },
        "|", // Separator
        {
          name: "preview",
          action: SimpleMDE.togglePreview,
          className: "fa fa-eye no-disable",
          title: "Toggle Preview",
        },

        {
          name: "side-by-side",
          action: SimpleMDE.toggleSideBySide,
          className: "fa fa-columns no-disable no-mobile",
          title: "Toggle Side by Side",
        },

        {
          name: "fullscreen",
          action: SimpleMDE.toggleFullScreen,
          className: "fa fa-arrows-alt no-disable no-mobile",
          title: "Toggle Fullscreen",
        },

        "|",
        {
          // name: "custom",
          action: (editor) => {
            this.saveContent()
          },
          className: "fa fa-cloud-upload",
          title: "Save",
        },
      ],

    });
      var inlineAttachmentConfig = {
        uploadUrl: `${this.$axios.defaults.baseURL}/api/img/upload`,               //后端上传图片地址
        uploadFieldName: 'file',          //上传的文件名
        jsonFieldName: 'url',              //返回结果中图片地址对应的字段名称
        progressText: '![图片上传中...]()',    //上传过程中用户看到的文案
        errorText: '图片上传失败',
        withCredentials: true, // 设置为 true 以携带凭据信息
        // urlText: '![图片描述]({filename})',    //上传成功后插入编辑器中的文案，{filename} 会被替换成图片地址
        urlText: (result) =>{
                              return `<img class="md-img " src="${result.url}" alt="[${result.id}-${result.filename}]">`
                              // return  `![${result.id}-${result.filename}](${result.url})`
                            },    //上传成功后插入编辑器中的文案，{filename} 会被替换成图片地址
        // extraHeaders: {
        //     'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        // }
      };
      inlineAttachment.editors.codemirror4.attach(this.simplemde.codemirror, inlineAttachmentConfig);
    },
    test(paths) {

      var curTagsId = []
      for (let i = 0; i < paths.length; i++) {
        let path = paths[i]
        let id = path[path.length-1]
        curTagsId.push(id)
      }

      let preLen = this.preTagsId.length
      let curLen = curTagsId.length

      // return
      let longerArr = this.preTagsId;
      let shortArr = curTagsId;

      if (preLen < curLen) { // 移除了1个
        longerArr = curTagsId;
        shortArr = this.preTagsId;
      }


      let targetId;
      for (let i = 0; i < longerArr.length; i++) {
        if (!shortArr.includes(longerArr[i])) {
          targetId = longerArr[i];
          break;
        }
      }
      this.preTagsId = [...curTagsId]

      if (preLen < curLen) {
        this.addTagApi(targetId)
      } else {
        this.removeTagApi(targetId)
      }

    },
    addTagApi(tagId) {
      this.$axios.post(`/api/articleCategory/link/${this.article.id}/${tagId}`)
        .then(res => {
          console.log(res)
        })
        .catch(e => {
          console.log(e)
        })
    },
    removeTagApi(tagId) {
      this.$axios.post(`/api/articleCategory/unlink/${this.article.id}/${tagId}`)
        .then(res => {
          console.log(res)
        })
        .catch(e => {
          console.log(e)
        })
    },
    fetchTagsById() {
      const id = this.article.id
      this.$axios.get(`/api/articleCategory/getCategoriesById/${id}`)
        .then(res => {
          console.log(res.data)
          console.log(147)
          this.preTagsId = res.data   // 集合相减的初始化
          this.tagsSelected = this.fromCategoryIdsToPaths(res.data)

        })
    },


    fromCategoryIdsToPaths(categoryIds) {

      const  _fromCategoryIdToPath = (id)=>{
        var category = this.tagsKv[id];
        var ret = []
        while (1) {
          ret.unshift(category.categoryId);
          let parentId = category.parentId;
          if (parentId) {
            category = this.tagsKv[parentId];
          } else {
            break
          }
        }
        return ret;
      }

      var ret = []
      for (let j = 0; j < categoryIds.length; j++) {
        ret.push(_fromCategoryIdToPath(categoryIds[j]));
        this.preTagsId.push[categoryIds[j]] //做集合相减的初始化
      }

      return ret;
    },
    fromPathsToCategoryIds(paths) {
      var ret = []
      for (let j = 0; j < paths.length; j++) {
        var path = paths[j]
        ret.push(path[path.length - 1]);
      }
      return ret;
    },
    fetchTags() {
      console.log("fetchTags")
      this.$axios.get(`/api/category/tree`)
        .then(res => {
          console.log(res.data)
          this.tags = res.data
        })
        .catch(err => {

        })
      this.$axios.get("/api/category/kv")
        .then(res => {
          console.log(res.data)
          this.tagsKv = res.data
          setTimeout(() => {
            this.fetchTagsById()
          }, 500);
        })
        .catch(err => {

        })
    },
    isDark() {
      return document.documentElement.getAttribute('data-bs-theme') == "light";
    },
    whatThemeNow() {
      const a = "//cdn.jsdelivr.net/simplemde/latest/simplemde.min.css";
      const b = "//cdn.rawgit.com/xcatliu/simplemde-theme-dark/master/dist/simplemde-theme-dark.min.css"


      if (
        this.isDark()
      ) {
        require('simplemde/dist/simplemde.min.css')
      } else {
        const style = document.createElement('link');
        style.rel = 'stylesheet';
        style.href = "//cdn.rawgit.com/xcatliu/simplemde-theme-dark/master/dist/simplemde-theme-dark.min.css";
        document.head.appendChild(style);
      }


    },
    saveContent() {

      this.article.content = this.simplemde.value()
      this.$axios.post("/api/article/upload",
        this.article
      ).then(res => {
        this.article.id = res.data.id  // init if necessary
        this.$message.success('Done');
      })
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
      // console.log(res)
      this.article.coverId = res.id

    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      return isLt2M;
    },
    addItem(a, b) {
      console.log(a, b)
    }
  },
};
</script>



<style lang="less" scoped>
@coverSize: 15vw;
@infoSize: ~"calc(90vw - @{coverSize})";

#mdInfos {


  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 5px;

  >#mdCover {
    width: @coverSize;
    height: @coverSize;
    border-radius: 5px;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;


    .avatar {
      //外面还包了一层
      width: @coverSize;
      height: @coverSize;
      object-fit: cover;
    }

    /deep/ .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: @coverSize;
      height: @coverSize;
      line-height: @coverSize;
      text-align: center;
    }

  }

  >#mdCover:hover {
    border-color: #409EFF;
  }

  >#mdComments {
    width: @infoSize;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .el-input {
      padding: 5px 0; //防止多个输入框竟贴着
    }
  }
}
</style>